import { startLinkProps, trainingPlan } from '../data';

function CheckList({ items }) {
  return (
    <ul className="check-list">
      {items.map((item) => (
        <li key={item}>
          <span className="check" aria-hidden="true">
            ✓
          </span>
          {item}
        </li>
      ))}
    </ul>
  );
}

export default function TrainingPricing() {
  return (
    <section className="section training-pricing" id="training" aria-labelledby="training-heading">
      <div className="container">
        <article className="training-card" data-reveal>
          <div className="training-card-copy">
            <p className="eyebrow">Training</p>
            <h2 className="display-2" id="training-heading">
              {trainingPlan.name}
            </h2>
            <p className="training-price">
              <span className="price-figure">{trainingPlan.price}</span>
              <span className={`price-unit${trainingPlan.flushUnit ? ' is-flush' : ''}`}>
                {trainingPlan.unit}
              </span>
            </p>
            <p className="training-copy">{trainingPlan.copy}</p>
            <a className="btn btn-training" {...startLinkProps}>
              Schedule a session
            </a>
          </div>

          <div className="training-card-includes">
            <p className="includes-label">Included</p>
            <CheckList items={trainingPlan.items} />
          </div>
        </article>
      </div>
    </section>
  );
}
